import {
  GetAccountInfoApiProps,
  GetAccountInfoARApiProps,
  UpdateAliasApiProps,
  UpdateAliasResponseApiProps,
} from 'services/account-info/types'
import { interWbHttp } from 'mocks/interWbHttp'

export const getAccountInfo = async (): Promise<GetAccountInfoApiProps> => {
  const endpoint = 'app-pf/international-account/bff/global-account/v1/screens/dados-bancarios'

  const { response } = await interWbHttp.get({
    endpoint,
    org: 'US_BRANCH',
  })

  return JSON.parse(response)
}

export const getAccountInfoAR = async (
  account: string,
  localization?: string,
): Promise<GetAccountInfoARApiProps> => {
  const endpoint = `app-pf/international-account/bff/global-account/v1/screens/dados-bancarios?type=${account}`

  const headers = {
    localization: localization ?? 'en-US',
  }

  const { response } = await interWbHttp.get({
    endpoint,
    headers,
  })

  const parsedResponse = JSON.parse(response)
  return parsedResponse
}

export const updateAlias = async (
  props: UpdateAliasApiProps,
): Promise<UpdateAliasResponseApiProps> => {
  const endpoint = 'app-pf/international-account/bff/global-account/v1/alias/configuration'

  const headers = {
    'Content-Type': 'application/json',
  }

  const { response } = await interWbHttp.post({
    endpoint,
    body: {
      cvuAr: props.cbuCvu,
      aliasAr: props.alias,
    },
    headers,
  })

  const parsedResponse = JSON.parse(response)
  return parsedResponse
}
